import styled from "styled-components";

export const Container = styled.div`
  padding: 10px;
  width: 100%;
  aspect-ratio: 1.75/1;
  overflow: hidden;
`;
